import { NgClass, NgTemplateOutlet } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	input,
	ViewEncapsulation,
} from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';
import { SvgIconComponent } from 'angular-svg-icon';

import { TooltipComponent } from '@valk-nx/components/ui-tooltip/src/lib/tooltip.component';
import { TooltipContentDirective } from '@valk-nx/components/ui-tooltip/src/lib/tooltip-content.directive';
import { PricingSummaryComponent } from '@valk-nx/compositions/ui-pricing-summary/src/lib/pricing-summary';
import { BaseDirective } from '@valk-nx/core/lib/directives/base/base.directive';
import { PricingTooltip } from '@valk-nx/helpers/lib/pricing-tooltip/pricing-tooltip.interface';

import { PriceComponent } from './components/price/price';

@Component({
	host: { ngSkipHydration: 'true' },
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	selector: 'vp-pricing',
	templateUrl: './pricing.html',
	imports: [
		NgClass,
		NgTemplateOutlet,
		PriceComponent,
		PricingSummaryComponent,
		SvgIconComponent,
		TooltipComponent,
		TooltipContentDirective,
		TranslatePipe,
	],
})
export class PricingComponent extends BaseDirective {
	price = input.required<number>();
	fromPrice = input<number>(0);
	indication = input<boolean>(false);
	conditions = input<string>('');
	currency = input<string>('EUR');
	size = input<'sm' | 'base' | 'lg' | 'xl'>('base');
	alignment = input<'self-start' | 'self-end'>('self-end');
	isHorizontal = input<boolean>(false);
	requestPrice = input<boolean>(false);
	pricingToolTip = input<PricingTooltip | undefined>(undefined);

	currentLang = this.translate.getCurrentLang();

	constructor() {
		super();
	}
}
